import apiClient from '../../core/apiClient';
import { SuperAdminAnalyticsResponse } from '../../types/api';

export const financeService = {
  getPlatformAnalytics: async () => {
    const response = await apiClient.get<SuperAdminAnalyticsResponse>('/api/finance/metrics');
    return response.data;
  },
  getReconciliationStatus: async () => {
    const response = await apiClient.get<{ status: string }>('/api/finance/reconciliation-status');
    return response.data;
  }
};
